import Modal from "../Modal/Modal";
import BranchSelect from "../Select/BranchSelect";

const BranchSelectModal = () => {
  return (
    <Modal>
      <div className="h-32">
        <BranchSelect />
      </div>
    </Modal>
  );
};
export default BranchSelectModal;
